import TextLink from '@/atoms/Links/Text/TextLink';
import Image from 'next/image';
import {StyledReturnPolicyLink} from './styles';

const ReturnPolicy = () => {
  return (
    <StyledReturnPolicyLink>
      <Image
        src={'https://d2m7ibezl7l5lt.cloudfront.net/img/v2/shield2.svg'}
        width={42}
        height={50}
        alt={'14 day money back guarantee'}
      />
      Free returns
      <p>
        <span>14 day money back guarantee</span>
        <TextLink
          href={'/help/returns-and-refunds'}
          target={'_blank'}
          title={'Learn more about our money back guarantee policy'}
          fontSize={14}
        >
          Learn more
        </TextLink>
      </p>
    </StyledReturnPolicyLink>
  );
};

export default ReturnPolicy;
